module.exports = __webpack_public_path__ + "static/media/cross.56540dc8.svg";